import { Tab as MuiTab, TabProps as MuiTabProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Stack from "@readai/pulse/components/Stack";

export interface TabProps extends MuiTabProps {
  /** If true, will not make the tabs shorter on smaller screens */
  disableMobileHeight?: boolean;
}

const Tab = styled(({ icon, disableMobileHeight: _d, ...props }: TabProps) => (
  <MuiTab
    icon={
      icon ? (
        <Stack variant="center" className="svgWrapper">
          {icon}
        </Stack>
      ) : undefined
    }
    {...props}
  />
))(({ theme, disableMobileHeight = false }) => ({
  minHeight: "48px",
  height: "48px",
  fontSize: "1rem",
  lineHeight: "20px",
  letterSpacing: "-0.02rem",
  fontWeight: 500,
  color: theme.palette.text.weak,
  borderRadius: "6px",
  whiteSpace: "nowrap",

  "&:hover": {
    color: theme.palette.text.med,

    "& .svgWrapper": {
      background: theme.palette.shades.primary[50],
    },
    "& svg": {
      color: theme.palette.icon.brand.default,
    },
  },

  "&.Mui-selected": {
    color: theme.palette.text.brand.default,
    "& .svgWrapper": {
      background: theme.palette.shades.primary[50],
    },
    "& svg": {
      color: theme.palette.icon.brand.default,
    },
  },

  "& .svgWrapper": {
    background: theme.palette.shades.neutral[50],
    width: "24px",
    height: "24px",
    borderRadius: "12px",
  },

  "& svg": {
    color: theme.palette.icon.weak,
    width: "16px",
    height: "16px",
  },

  "&.Mui-disabled": {
    fontWeight: 400,
    color: theme.palette.shades.neutral[300],
  },

  [theme.breakpoints.down("mobile")]: {
    ...(!disableMobileHeight && {
      minHeight: "36px",
      height: "36px",
    }),
    padding: theme.spaces.small,
    borderRadius: "6px",
  },
}));

export default Tab;
